export const wait = (x: number) => new Promise((s) => setTimeout(s, x, x));
export interface Noop {
  (...x: unknown[]): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop: Noop = (...x: unknown[]): void => {};
export const SortAlpha = (order: any) => (a: any, b: any) =>
  a.title > b.title ? order * 1 : a.title === b.title ? 0 : order * -1;


export const hasCommon = (a: any[], b: any[]) => a.some((v) => b.includes(v));
export const pluck = (a: any, k: any) => a.map((v: any) => v[k]);
